import { useEffect, useState } from "react";
import styles from "./action.module.css";
import classNames from "classnames";
import translations from "../const";

const LowVisionProfile = () => {
  const [active, setActive] = useState(false);
  const [lang, setLang] = useState("es-ES");

  useEffect(() => {
    setLang(document.documentElement.getAttribute("lang") || "es-ES");
  }, []);

  useEffect(() => {
    if (active) {
      // 1️⃣ Texto grande (simular nivel 2)
      document.body.classList.add(styles.letter_spacing_1);
      document.body.classList.add(styles.line_height_1);

      // 2️⃣ Resaltar enlaces
      document.querySelectorAll("a").forEach((el) => {
        el.classList.add(styles.highlight_links);
      });

      // 3️⃣ Cursor visible (reuse lógica actual)
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
          <circle cx="16" cy="16" r="15" stroke="black" stroke-width="2" fill="white"/>
        </svg>`;
      const cursor = `url(data:image/svg+xml;base64,${btoa(svg)}) 16 16, auto`;
      document.querySelectorAll("*").forEach((el) => {
        el.style.cursor = cursor;
      });

      // 4️⃣ Texto más grande (rápido / actual)
      document
        .querySelectorAll("p,h1,h2,h3,h4,h5,h6,a,strong,b")
        .forEach((el) => {
          const size = parseFloat(window.getComputedStyle(el).fontSize);
          el.setAttribute("data-fontsize-profile", size);
          el.style.fontSize = size + 4 + "px";
        });

    } else {
      // RESET
      document.body.classList.remove(styles.letter_spacing_1);
      document.body.classList.remove(styles.line_height_1);

      document.querySelectorAll("a").forEach((el) => {
        el.classList.remove(styles.highlight_links);
      });

      document.querySelectorAll("*").forEach((el) => {
        el.style.cursor = "";
      });

      document
        .querySelectorAll("[data-fontsize-profile]")
        .forEach((el) => {
          el.style.fontSize = el.getAttribute("data-fontsize-profile") + "px";
          el.removeAttribute("data-fontsize-profile");
        });
    }
  }, [active]);

  return (
    <button
      onClick={() => setActive(!active)}
      className={classNames(styles.btn, {
        [styles.active]: active,
      })}
      aria-pressed={active}
      aria-label="Perfil de accesibilidad: visión baja"
    >
      <div className={styles.active_label}>
        <svg height="16" viewBox="0 -960 960 960" width="16" fill="white">
          <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
        </svg>
      </div>

      <svg
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#5f6368"
        aria-hidden="true"
      >
        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-80q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29Zm0 240q-146 0-264-82T80-500q54-96 172-178t228-82q110 0 228 82t172 178q-54 96-172 178t-228 82Z" />
      </svg>

      <span>{translations[lang].low_vision || "Visión baja"}</span>
    </button>
  );
};

export default LowVisionProfile;
